/**
 * Currency formatting utilities for LossPay
 * 
 * Formatting rules:
 * - Use dollar sign and comma separators
 * - If amount ends in .00, do NOT display decimals
 * - If amount contains cents other than .00, display exactly two decimal places
 * 
 * Examples:
 * - $192
 * - $500
 * - $3,937.50
 * - $31,500
 */

export const formatCurrency = (amount) => {
  const num = parseFloat(amount) || 0;
  
  // Check if amount is a whole number
  if (num % 1 === 0) {
    return `$${num.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  }
  
  // Amount has cents - display exactly 2 decimal places
  return `$${num.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}`;
};

/**
 * Format currency without dollar sign
 */
export const formatCurrencyValue = (amount) => {
  const num = parseFloat(amount) || 0;
  
  if (num % 1 === 0) {
    return num.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
  
  return num.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
};

export default formatCurrency;
